const teamCarousel = (width) => {

    const slider = $('.js-team-carousel');

    if ( slider.length ) {
        const hiddenClass    = 'team-carousel--hidden';
        const slidesToScroll = Math.ceil($('.js-team-carousel .team-carousel__element').not('.slick-cloned').length/3);
        slider.on('init', function(event, slick){
            slider.removeClass(hiddenClass);
        });

        $(window).on('load resize', function(){
            if ( window.deviceWidth >= width ) {
                //slider.slick('reinit');
            }
        });

        slider.slick({
            slidesToShow    : 5,
            slidesToScroll  : slidesToScroll,
            variableWidth   : true,
            rows            : 0,
            infinite        : false,
            arrows          : true,
            dots            : true,
            prevArrow       : '<button type="button" class="slick-prev"><svg class="i"><use xlink:href="#stroke-arrow-left"/></svg></button>',
            nextArrow       : '<button type="button" class="slick-next"><svg class="i"><use xlink:href="#stroke-arrow-right"/></svg></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow    : 2,
                        slidesToScroll  : 2
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow    : 2,
                        variableWidth   : false,
                        rows            : 2
                    }
                }
            ]
        });

    }
}